import { IconName } from '@blueprintjs/icons';
import classNames from 'classnames';
import React, { ReactNode } from 'react';
import Box, { BoxProps } from 'ui-box';
import { Icon, Heading, majorScale, minorScale } from '.';
import { Card, ICardProps } from './Card';
import { getColorFromIntent, Intents } from './Intents';

export interface IMenuProps extends ICardProps {}

export const Menu: React.FC<IMenuProps> = ({ children, ...props }) => (
  <Card
    className="menu"
    backgroundColor="white"
    elevation={2}
    minWidth="160px"
    {...props}
  >
    {children}
  </Card>
);

export const MenuItem = ({
  text,
  icon,
  intent = 'none',
  disabled = false,
  className = '',
  onClick,
  ...props
}: {
  text: string | ReactNode;
  icon?: IconName;
  intent?: Intents;
  disabled?: boolean;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
} & BoxProps<'div'>) => (
  <Box
    {...props}
    className={classNames('item', intent, disabled && 'disabled', className)}
    onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
      !disabled && onClick && onClick(event)
    }
  >
    {icon && (
      <Icon
        icon={icon}
        color={getColorFromIntent(intent)}
        marginRight={majorScale(1)}
        flexShrink={0}
      />
    )}{' '}
    {text}
  </Box>
);

export const MenuDivider = ({ text }: { text?: string }) => (
  <Box className="divider">
    {text && (
      <Heading paddingX={majorScale(2)} marginTop={minorScale(3)} size={100}>
        {text}
      </Heading>
    )}
  </Box>
);
